import { useState } from 'react';

/**
 * Paginação das listas do módulo 03, para o `RodapeTabela` (p.18): "Mostrando
 * 1–10 de 42" à esquerda, paginação ao centro, itens por página à direita.
 *
 * As listas daqui já chegam inteiras do servidor (com o teto de cada rota), e
 * a página é recortada na tela — o mesmo desenho das listas de equipamentos,
 * cadastros e combustível, com as mesmas opções.
 */
export const PADRAO_POR_PAGINA = 10;
export const OPCOES_POR_PAGINA: readonly number[] = [10, 25, 50, 100];

export function usePaginacao<T>(linhas: readonly T[]) {
  const [pagina, setPagina] = useState(1);
  const [porPagina, setPorPagina] = useState(PADRAO_POR_PAGINA);

  const paginas = Math.max(Math.ceil(linhas.length / porPagina), 1);
  /* Filtro que encolhe a lista não pode deixar a tela na página 3 de 1. */
  const paginaSegura = Math.min(pagina, paginas);
  const inicio = (paginaSegura - 1) * porPagina;
  const visiveis = linhas.slice(inicio, inicio + porPagina);

  return {
    visiveis,
    rodape: {
      primeiro: linhas.length === 0 ? 0 : inicio + 1,
      ultimo: inicio + visiveis.length,
      total: linhas.length,
      pagina: paginaSegura,
      paginas,
      porPagina,
      opcoesPorPagina: OPCOES_POR_PAGINA,
      aoMudarPagina: setPagina,
      aoMudarPorPagina: (novo: number) => {
        setPorPagina(novo);
        setPagina(1);
      },
    },
  };
}
